/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EnumMediaEntities } from '../../models/enum-media-entities';
import { MediaTypeResponse } from '../../models/media-type-response';

export interface MediaTypeControllerFindAll$Params {

/**
 * Tipo di entità
 */
  entity?: EnumMediaEntities;
}

export function mediaTypeControllerFindAll(http: HttpClient, rootUrl: string, params?: MediaTypeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaTypeControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('entity', params.entity, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaTypeResponse;
      }>;
    })
  );
}

mediaTypeControllerFindAll.PATH = '/file-manager/types';
